import moment from 'moment';
import { humanise } from 'components/atoms/humanised-date';
import { useTranslate } from 'hooks/use-translation';
import { ProjectTimelineEvent } from '../../event-types';

export const projectTimelineTemplate = (
  {
    startDate,
    endDate,
    id,
  }: Pick<ProjectTimelineEvent, 'startDate' | 'endDate' | 'id'>,
  translate: ReturnType<typeof useTranslate>,
): string =>
  `<div class="content" data-event-id=${id}>
  <span class="label">${translate(
    'project_dates',
  )}:</span><strong class="value"> ${humanise(moment(startDate))} - ${humanise(
    moment(endDate),
  )}</strong></div>`;

export const projectTimelineTooltip = (
  { startDate, endDate }: Pick<ProjectTimelineEvent, 'startDate' | 'endDate'>,
  translate: ReturnType<typeof useTranslate>,
): string =>
  `<span>${translate('project_dates')}:</span><strong> ${humanise(
    moment(startDate),
  )} - ${humanise(moment(endDate))}</strong>`;
